import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    iconComponent: { name: 'cil-speedometer' },
    badge: { color: 'info', text: 'NEW' }
  },
  {
    name: 'Master',
    iconComponent: { name: 'cil-storage' },
    children: [
      { name: 'New Ledger', url: '/master/newledger', iconComponent: { name: 'cil-user-follow' } },
      { name: 'Product', url: '/product/products', iconComponent: { name: 'cil-layers' } },
      { name: 'Orders', url: '/orders/neworders', iconComponent: { name: 'cil-clipboard' } },
    ]
  },
  {
    name: 'Transaction',
    iconComponent: { name: 'cil-swap-horizontal' },
    children: [
      { 
        name: 'Challan Book', 
        iconComponent: { name: 'cil-truck' },
        children: [
          { name: 'Challan', url: '/deliverychallan/newchallan', iconComponent: { name: 'cil-pencil' } },
          { name: 'List Challan', url: '/deliverychallan/challnbook', iconComponent: { name: 'cil-list' } },
        ] 
      },
      { 
        name: 'Purchase Transaction', 
        iconComponent: { name: 'cil-basket' },
        children: [
          { name: 'Add Purchase', url: '/purchase/addpurchase', iconComponent: { name: 'cil-plus' } },
          { name: 'View Transactions', url: '/purchase/viewpurchase', iconComponent: { name: 'cil-search' } },
        ] 
      },
      { 
        name: 'Sale Transaction', 
        iconComponent: { name: 'cil-cart' },
        children: [
          { name: 'New Sale', url: '/sales/addsale', iconComponent: { name: 'cil-pencil' } },
          { name: 'View Sale', url: '/sales/viewsale', iconComponent: { name: 'cil-description' } },
          { name: 'Sale Bill', url: '/sales/viewbill', iconComponent: { name: 'cil-print' } },
        ] 
      },
      { 
        name: 'GST Calculate', 
        iconComponent: { name: 'cil-calculator' },
        children: [
          { name: 'GST', url: '/gstmain/gst', iconComponent: { name: 'cil-task' } },
        ] 
      },
    ]
  },
  {
    name: 'Payment Master',
    iconComponent: { name: 'cil-bank' },
    children: [
      { name: 'Add Payment', url: '/payment/addpayment', iconComponent: { name: 'cil-money' } },
      { name: 'View Payment', url: '/payment/vouchers', iconComponent: { name: 'cil-money' } },
    ]
  },
];
